import React, { useState, useRef, useEffect, useContext } from 'react'
import './css/AddItem.css'
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import UploadImg from './images/MenuReg/uploadItem.png'
import Rupee from './images/MenuReg/Rupee1.png'
import { useNavigate, useLocation } from 'react-router-dom';
import AddVarientModel from './AddVarientModel';
import Info from './images/icons/info.png';
import InfoError from './images/icons/infoRed.png';
import Tick from './images/icons/tick.png'
import Tick1 from './images/icons/tick1.png'
import Upp from './images/icons/up-arrow.png'
import Rightt from './images/icons/right-arrow.png'
import cross from './images/icons/cross.png'
import domain from './images/icons/domain.png'
import fileUpload from './images/icons/image-.png'
import rightarrow from './images/Mobile/Upload (1).png'
import uparrow from './images/Mobile/Upload.png'
import Area from './js/areas.json'
import Editing1 from './images/MenuReg/Editing1.png'
import Redeye1 from './images/MenuReg/Redeye1.png'
import AddCombo from './images/icons/AddCombo.png'
import Minus1 from './images/icons/minu1.png'
import Select from 'react-select'
import { ToastContainer, toast } from 'react-toastify';
import { DBContext } from './DBContext'
import axios from 'axios';
import searchingLotties from './images/lotties/searchingLottie.json'
import noImage from './images/icons/depositphotos_247872612-stock-illustration-no-image-available-icon-vector.jpg'
import io from 'socket.io-client';
import Lottie from "lottie-react";
import SideNavMob from './SideNavMob'
import RightNavMob from './RightNavMob'
import NavBarMobile from './Mobile/NavBar'

function EditItem() {
    const location = useLocation(null)
    const { id_productReg } = location.state || {}; // Safely access the id    

  //(id_productReg , "from edit item id_productReg")
    const [categories, setCategories] = useState([]);
    const [Kitchens, setKitchens] = useState([]);
    const [company, setCompany] = useState(localStorage.getItem('Company'));
    const [loadingCate, setLoadingCate] = useState(true); // To track the loading state
    const [loadingKitchen, setLoadingKitchen] = useState(true); 
    const [itemDetails, setItemDetails] = useState({}) 
    const [cateFromDb, setCateFromDb] = useState()
        const [area, setArea] = useState([])


    //('cateFromDb',cateFromDb);
    console.log(itemDetails, "itemDetails");
    
    const [kitchenFromDb, setKitchenFromDb] = useState()
    const [foodTypeFromDb, setFoodTypeFromDb] = useState()
    const [subKitchenFromDb, setSubKitchenFromDb] = useState()
    const [taxFromDb, setTaxFromDb] = useState()
    const [kitchenOptions,setKitchenOptions] = useState([])
    const [subKitchenOptions,setSubKitchenOptions] = useState([])
    const [foodTypeOptions,setFoodTypeOptions] = useState([])
    const [allProductsOptions, setAllProductsOptions] = useState([])
    const [poolFromDb, setPoolFromDb] = useState(null)
    
    const api_base_url = process.env.REACT_APP_API_BASE_URL

    const { customerCode , logginedDB , user_Id , sideNavState , sideNavStateFunc , rightNavState , rightNavStateFunc } = useContext(DBContext);
    
    const [selectedOption, setSelectedOption] = useState({})

    const [taxOptions,setTaxOptions] = useState([])
    const [preview, setPreview] = useState(null);

    //(preview, "p");



    
     const socketRef = useRef(null);
     const [item, setItem] = useState({});
     const productID = location.state;

          useEffect(() => {
              if (!logginedDB) return;
      
              handleGetCategories(); 
              handleGetKitchen();
              handleGetFoodType();
              handleGetAreas();
              handGetTaxGroups();
              handleGetProducts();
      
              socketRef.current = io(api_base_url, {
                  transports: ["websocket"],
              });
      
              // Event listeners
              const geteHandlerCategories = () => handleGetCategories(); 
              const getHandlerKitchen = () =>  handleGetKitchen();
              const getHandleFoodType = () =>   handleGetFoodType();
            const getHandleAreas = () =>     handleGetAreas();

      
              socketRef.current.on("connect", () => {
                  console.log("Connected to server");
              });
      
              socketRef.current.on("disconnect", () => {
                  console.log("Disconnected from server");
              });
      
              socketRef.current.on("connect_error", (error) => {
                  console.error("Connection error:", error);
              });
      
      
              socketRef.current.on("createdCategory", geteHandlerCategories);
              socketRef.current.on("createdKitchen", getHandlerKitchen);
              socketRef.current.on("createdFoodType", getHandleFoodType);
              socketRef.current.on("createdArea", getHandleAreas);

      
              return () => {
                  if (socketRef.current) {
                      socketRef.current.off("createdCategory", geteHandlerCategories);
                      socketRef.current.off("createdKitchen", getHandlerKitchen);
                      socketRef.current.off("createdFoodType", getHandleFoodType);
                      socketRef.current.off("createdArea", getHandleAreas);

                      socketRef.current.disconnect();
                  }
              };
          }, [api_base_url, logginedDB]);



    useEffect(() => {
        const handleModifyItem = async () => {
            try {
                const response = await fetch(`${api_base_url}/getItemEdit/${logginedDB}/${customerCode}/${id_productReg}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                
                const data = await response.json();
                if (data.success) {
                    const { 0: productData, variants, areaRates } = data.data;

                    // Merge into a single object
                    const datas = {
                        ...productData, 
                        variants: variants || [], 
                        areaRates: areaRates || []
                    };                    
                    
                    setItem(datas);
                    setItemDetails((prev) => ({
                        ...prev,
                        'itemName': datas.productName,
                        'regionalName': datas.regionalName,
                        'SubKitchen': datas.subKitchen,
                        'Kitchen': datas.KitchenName,
                        'Kitchen_id': parseInt(datas.kitchenId),
                        'itemCode': datas.itemCode,
                        'Category': datas.Category_Name,
                        'Category_id': parseInt(datas.categoryId),
                        'FoodType': datas.FoodType_name,
                        'FoodType_id': datas.FoodType_id,
                        'Tax': datas.id_tax,
                        'Cess': parseInt(datas.Cess),
                        'production_link_item_id': datas.production_link_item_id
                    }))

                    const imgg = datas.image
                    console.log(data, "datas");
                
                    setPreview(imgg ? imgg : 'undefined')
                    setImage(!imgg ? null : 'IsThere')
                    
                    if (datas.variants.length > 0) {
                        const formattedVariants = datas.variants.map(variant => ({
                            itemName: variant.varient_name,
                            itemPrice: variant.varient_rate,
                            isAdding: true
                        }));
                        setVariant_Price(formattedVariants);
                    }
                    
                    respectedAreaPrice()
                    
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };

        if (id_productReg) {
            handleModifyItem();
        }

    }, [id_productReg, api_base_url, logginedDB, customerCode]); 

    // Separate useEffect to handle option matching once data + options are available
    useEffect(() => {
        if (item && Object.keys(item).length > 0) {
             const selectedKitchen = kitchenOptions?.find(kitchen => kitchen.value === parseInt(item.kitchenId));
             const selectedCategory = categories.find(category => category.value === parseInt(item.categoryId));
             const selectedFoodType = foodTypeOptions.find(FoodType => FoodType.value === item.FoodType_id);
             const selectedTax = taxOptions.find(tax => tax.value === item.id_tax || tax.label === item.name);
             const selectedPool = allProductsOptions.find(prod => String(prod.value) === String(item.production_link_item_id));

             setCateFromDb(selectedCategory)
             setKitchenFromDb(selectedKitchen)
             setFoodTypeFromDb(selectedFoodType)
             setTaxFromDb(selectedTax)
             setPoolFromDb(selectedPool || null)
        }
    }, [item, kitchenOptions, categories, foodTypeOptions, taxOptions, allProductsOptions]);    
    




    const handleGetCategories = async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetCategories/${logginedDB}`)
            if (response.status == 200) {
                const transformedData = response.data.data.map(category => ({
                    value: category.id_category, 
                    label: category.Category_Name, 
                }));
                
                setCategories(transformedData)
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
            toast.error("Something went wrong while fetching categories data.",
            {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
        }
    }


    
    
    //("taxOptions", taxOptions);
    
    const handleGetKitchen = async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetKitchen/${logginedDB}`)
            if (response.status == 200) {
                const transformedData = response.data.map(item => ({
                    value: item.Kitchen_id, 
                    label: item.KitchenName, 
                }));
                
                setKitchenOptions(transformedData)
            }
        } catch (error) {
            
        }
    }

     const handleGetFoodType = async () => {
         try {
             const response = await axios.get(`${api_base_url}/GetFoodType/${logginedDB}`)
             if (response.status == 200) {
                 const transformedData = response.data.map(item => ({
                     value: item.FoodType_id, 
                     label: item.FoodType_name, 
                 }));
                 
                 setFoodTypeOptions(transformedData)
             }
         } catch (error) {
             
         }
     }

     const handleGetProducts = async () => {
         try {
             const response = await axios.get(`${api_base_url}/GetItemReg/${logginedDB}`);
             if (response.status === 200) {
                 const data = Array.isArray(response.data) ? response.data : (response.data.data || []);
                 // Do not allow linking to oneself!
                 const transformed = data
                     .filter(p => String(p.id_productReg) !== String(id_productReg))
                     .map(p => ({
                         value: p.id_productReg,
                         label: p.productName
                     }));
                 setAllProductsOptions(transformed);
             }
         } catch (error) {
             console.error("Error fetching products for pool linking:", error);
         }
     }

    const handGetTaxGroups = async () => {
        try {
            const response = await fetch(`${api_base_url}/getTaxGroups/${logginedDB}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();

            const transformedData = data.map(item => ({
                value: item.id_tax,
                label: item.name
            }));

            // //();
            
            //("transformedData", transformedData)
            setTaxOptions(transformedData);
            
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    const handleGetSubKitchen = async (id) => {
        try {
            const response = await axios.get(`${api_base_url}/GetSubKitchenOfKitchen/${id}/${logginedDB}`)
            if (response.status == 200) {
                const transformedData = response.data.map(item => ({
                    value: item.Sub_Kitchen_id, 
                    label: item.SubKitchenName, 
                }));
                
                setSubKitchenOptions(transformedData)
            }
        } catch (error) {
            //(error);
        }
    }


    const handleGetAreas = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getAreas/${logginedDB}`)
            if (response.status == 200) {
                setArea(response.data)
            }
        } catch (error) {
            //(error);
        }
    }

    // useEffect(() => {
    //     if (logginedDB) {
    //         handleGetKitchen()
    //         handleGetCategories()
    //         handleGetAreas()
    //         handGetTaxGroups()
    //         handleGetFoodType()
    //     }
    //     // Connect to the WebSocket server
    //     const socket = io(api_base_url);
    //     socket.on('createdCategory', () => {
    //         handleGetCategories();
    //     });
    //     socket.on('createdKitchen', () => {
    //         handleGetKitchen();
    //     });

    //     socket.on('createdFoodType', () => {
    //         handleGetFoodType();
    //     });
 
    //     return () => {
    //         socket.disconnect();
    //     };
    // },[api_base_url,logginedDB])

      
    
    //   useEffect(() => {
    //     if (!logginedDB) return; // if not logged in, skip
    
    //     // connect socket
    //     socketRef.current = io(api_base_url, {
    //       transports: ["websocket"], // faster than polling
    //     });
    
    //     // make sure old listeners are removed before adding new ones
    //     socketRef.current
    //       .off("createdCategory")
    //       .on("createdCategory", handleGetCategories());
    
    //     // socketRef.current
    //     //   .off("createdKitchen")
    //     //   .on("createdKitchen", handleGetKitchen());
    
    //     socketRef.current
    //       .off("createdFoodType")
    //       .on("createdFoodType", handleGetFoodType());
    
    //     // cleanup on unmount
    //     return () => {
    //       socketRef.current.disconnect();
    //     };
    //   }, [api_base_url, logginedDB]);
    




    //('item',item);
    

    // useEffect(() => {
    //     const handleModifyItem = async () => {
    //         try {
    //             const response = await fetch(`${api_base_url}/modifyItem/${logginedDB}/${productID}`, {
    //                 method: 'GET',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                 },
    //             });
    //             const data = await response.json();
    //             if (data.success) {
    //                 const datas = data.data[0]
    //                 setItem(datas);
    //                 setItemDetails((prev) => ({
    //                     ...prev,
    //                     'itemName': datas.productName,
    //                     'regionalName': datas.regionalName,
    //                     'SubKitchen': datas.subKitchen,
    //                     'Kitchen': datas.kitchen,
    //                     'itemCode': datas.itemCode,
    //                     'Category': datas.category,
    //                     'Tax': datas.Tax,
    //                     'Cess': datas.Cess
    //                 }))
    //             }
    //         } catch (error) {
    //             console.error('Error fetching items:', error);
    //         }
    //     };
    //     if (productID) {
    //         handleModifyItem();
    //     }

    // }, [api_base_url]);



    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            width: '100%',
            fontSize: '0.881rem',
            fontFamily: 'Nunito',
            backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
            backgroundColor: state.isFocused ? '#c8cbcf' : '#FFF',
            color: state.isFocused ? '#000' : '#000',
            ':active': {
                ...provided[':active'],
                backgroundColor: '#c8cbcf'
            }
        }),
        input: (provided) => ({
            ...provided,
            // height: '2.5rem',
            width: '100% !important',
            fontSize: '0.881rem',
            fontFamily: 'Nunito',
            cursor: 'none',
            '&:hover': {
                cursor: 'text'
            },
            '&:focus': {
                cursor: 'default',
            },
            // display: 'none', 
            color: "#2B3034"
        }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: 'hidden',
            fontSize: '0.881rem',
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            // display: 'none', 
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            height: '2.5rem', // Adjust height of dropdown indicator to match control height
            marginTop: 0, // Adjust vertical alignment if needed
        }),
        control: (provided, state) => ({
            ...provided,
            width: '100% !important',
            // height: '2.5rem',
            height: '1px',
            fontSize: '0.881rem',
            fontFamily: 'Nunito',
            height: '2.5rem',
            border: '1px solid #D5D5D5',
            borderRadius: '0.313rem',
            textAlign: 'left',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #C6C6C6',
            },
            '&:focus': {
                outline: 'none', // Remove outline on focus
                cursor: 'default', // Remove cursor on focus
            },
        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontSize: '0.881rem',
            // lineHeight: '2.5rem',
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: '.9rem',
            textAlign: 'left',
            // height: '2.5rem',
        }),
        container: (provided) => ({
            ...provided,
            height: '100%', // Set the height to 1px
        }),
        menuList: (provided, state) => ({
            ...provided,
            maxHeight: '150px',
            overflowY: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }),
    };


   
    

    useEffect(() => {
        if (selectedOption.Kitchen) {
            handleGetSubKitchen(selectedOption.Kitchen.value)
        }
    },[api_base_url,selectedOption])


    const currentDate = new Date().toISOString().split('T')[0];

    const formatTime = () => {
        let now = new Date();
        let hours = now.getHours();
        let minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
        minutes = minutes.toString().padStart(2, '0'); // Ensure two-digit minutes
        return `${hours}:${minutes} ${ampm}`;
    };

    const eventDetails = {
        ddate: currentDate,
        ttime: formatTime(),
        user_Id: user_Id, // Replace with actual user ID variable
        // user: userName // Replace with actual user variable
    };

    // const handleSelectField = (value, fieldName, itemField) => {
    //     if (!value) {
    //         //(`${fieldName} selection is empty. Aborting operation.`);
    //         return; // Exit if the value is null or undefined
    //     }
    
    //     //(value, `Selected value for ${fieldName}`);
    
    //     // Separate logic for Category and Kitchen
    //     if (fieldName === "Category") {
    //         const isRegistered = categories.some((category) => category.label === value.label);
    //         //(isRegistered, "cate isReg")

    //         if (!isRegistered) {
    //             const confirmRegister = window.confirm("Not Registered. Do you want to register this category?");
    //             if (confirmRegister) {
    //                 //("User chose to register the category:", value);
    //                 const today = new Date();
    //                 const newCategory = { CategoryName: value.value || value, CategoryCode: value.label || value, Date: today };
    //                 setCategories((prev) => [...prev, newCategory]);
    
    //                 // Send new category to the backend
    //                 fetch(`${api_base_url}/CategoryReg/${logginedDB}`, {
    //                     method: "POST",
    //                     headers: {
    //                         "Content-Type": "application/json",
    //                     },
    //                     body: JSON.stringify(newCategory),
    //                 })
    //                     .then((response) => {
    //                         if (response.ok) {
    //                             //("Category registered successfully!");
    //                             toast.success("Category registered successfully!", {
    //                                 className: 'custom-toast',
    //                                 bodyClassName: 'custom-toast-container',
    //                                 closeButtonClassName: 'custom-toast-close-button',
    //                                 onClose: () => { }
    //                             })
    //                         } else {
    //                             console.error("Failed to register category.");
    //                         }
    //                     })
    //                     .catch((error) => console.error("Error registering category:", error));
    //             } else {
    //                 //("User declined to register the category.");
    //                 return; // Exit if the user does not want to register
    //             }
    //         } else {
    //             setCateFromDb(value)
    //         }
    //     } else if (fieldName === "Kitchen") {
    //         const isRegistered = kitchenOptions.some((kitchen) => kitchen.label === value.label);
    //         //(isRegistered, "kitc isReg")
    //         if (!isRegistered) {
    //             const confirmRegister = window.confirm("Not Registered. Do you want to register this kitchen?");
    //             if (confirmRegister) {
    //                 //("User chose to register the kitchen:", value);
    //                 const today = new Date();
    //                 const newKitchen = { KitchenName: value.value || value, KitchenCode: value.label || value, Date: today };
    //                 setKitchenOptions((prev) => [...prev, newKitchen]);
    //                 //(newKitchen, "newKitchen new")
    //                 // Send new kitchen to the backend
    //                 fetch(`${api_base_url}/KitchenReg/${logginedDB}`, {
    //                     method: "POST",
    //                     headers: {
    //                         "Content-Type": "application/json",
    //                     },
    //                     body: JSON.stringify(newKitchen),
    //                 })
    //                     .then((response) => {
    //                         if (response.ok) {
    //                             //("Kitchen registered successfully!");
    //                             toast.success("Kitchen registered successfully!", {
    //                                 className: 'custom-toast',
    //                                 bodyClassName: 'custom-toast-container',
    //                                 closeButtonClassName: 'custom-toast-close-button',
    //                                 onClose: () => { }
    //                             })
    //                         } else {
    //                             console.error("Failed to register kitchen.");
    //                         }
    //                     })
    //                     .catch((error) => console.error("Error registering kitchen:", error));
    //             } else {
    //                 //("User declined to register the kitchen.");
    //                 return; // Exit if the user does not want to register
    //             }
    //         } else {
    //             setKitchenFromDb(value)
    //         }
    //     } 
    //     // else if (fieldName === "FoodType") {
    //     //     setFoodTypeFromDb(value)
    //     // } 
    //     else if (fieldName === "FoodType") {
    //         const isRegistered = foodTypeOptions.some((type) => type.label === value.label);
    //         //(isRegistered, "kitc isReg")
    //         if (!isRegistered) {
    //             const confirmRegister = window.confirm("Not Registered. Do you want to register this foodtype?");
    //             if (confirmRegister) {
    //                 //("User chose to register the kitchen:", value);
    //                 const today = new Date();
    //                 const newFoodType = { FoodType_name: value.value || value, FoodType_id: value.label || value, Date: today };
    //                 setFoodTypeOptions((prev) => [...prev, newFoodType]);
    //                 //(newKitchen, "newKitchen new")
    //                 // Send new kitchen to the backend
    //                 fetch(`${api_base_url}/FoodTypeReg/${logginedDB}`, {
    //                     method: "POST",
    //                     headers: {
    //                         "Content-Type": "application/json",
    //                     },
    //                     body: JSON.stringify(newFoodType),
    //                 })
    //                     .then((response) => {
    //                         if (response.ok) {
    //                             //("Kitchen registered successfully!");
    //                             toast.success("footType registered successfully!", {
    //                                 className: 'custom-toast',
    //                                 bodyClassName: 'custom-toast-container',
    //                                 closeButtonClassName: 'custom-toast-close-button',
    //                                 onClose: () => { }
    //                             })
    //                         } else {
    //                             console.error("Failed to register footType.");
    //                         }
    //                     })
    //                     .catch((error) => console.error("Error registering footType:", error));
    //             } else {
    //                 //("User declined to register the kitchen.");
    //                 return; // Exit if the user does not want to register
    //             }
    //         } else {
    //             setFoodTypeFromDb(value)
    //         }
    //     } else if (fieldName === 'tax') {
    //         setTaxFromDb(value)
    //     }
    
    //     // General logic for updating state
    //     // setSelectedOption((prev) => ({
    //     //     ...prev,
    //     //     [fieldName]: value,
    //     // }));
        
    //     setItemDetails((prev) => ({
    //         ...prev,
    //         [fieldName]: value,
    //     }));
    
    //     item[itemField] = ''; // Reset the corresponding field
    // };
    
    // useEffect(() => {
    //     if (itemDetails) {
    //         setSelectedOption({
    //             Category: categories.find(c => c.label === itemDetails.category) || null,
    //             Kitchen: kitchenOptions.find(k => k.label === itemDetails.kitchen) || null,
    //             subKitchen: subKitchenOptions.find(sk => sk.label === itemDetails.subKitchen) || null
    //         });
    //         //(selectedOption, "selectedOption")
    //     }
    // }, [itemDetails, categories, kitchenOptions, subKitchenOptions]);

 const handleSelectField = async (value, fieldName, itemField) => {
        // //('fieldnaem', fieldName);

        if (!value) {
            //(`${fieldName} selection is empty. Aborting operation.`);
            return; // Exit if the value is null or undefined
        }

        //(value, `Selected value for ${fieldName}`);

        // Separate logic for Category and Kitchen
        if (fieldName === "Category") {
            const isRegistered = categories.some((category) => category.label === value.label);
            //(isRegistered, "cate isReg")
            
            if (!isRegistered) {
                const confirmRegister = window.confirm("Not Registered. Do you want to register this category?");
                if (confirmRegister) {
                    //("User chose to register the category:", value);
                    const today = new Date();
                    const newCategory = { CategoryName: value.value || value, CategoryCode: value.label || value, Date: today };
                    setCategories((prev) => [...prev, newCategory]);

                    // Send new category to the backend
                    fetch(`${api_base_url}/CategoryReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(newCategory),
                    })
                        .then((response) => {
                            if (response.ok) {
                                //("Category registered successfully!");
                                toast.success("Category registered successfully!", {
                                    className: 'custom-toast',
                                    bodyClassName: 'custom-toast-container',
                                    closeButtonClassName: 'custom-toast-close-button',
                                    onClose: () => { }
                                })
                                //('value.value',value);
                                
                                
                                setCateFromDb(value)

                                const lastValue = categories.length > 0 ? categories[categories.length - 1].value + 1 : 1;

                                // //('categories',categories);
                                // //('selectedCategory',selectedCategory);
                                
                                setItemDetails((prev) => ({
                                    ...prev,
                                    [fieldName]: value.label
                                }));

                                setItemDetails((prev) => ({
                                    ...prev,
                                    [`${fieldName}_id`]: lastValue
                                }));
                                
                                
                            } else {
                                console.error("Failed to register category.");
                            }
                        })
                        .catch((error) => console.error("Error registering category:", error));
                } else {
                    //("User declined to register the category.");
                    return; // Exit if the user does not want to register
                }
            } else {
                setCateFromDb(value)

                // //('valuevalue',value);
                

                // const selectedCategory = categories.find(category => category.label === value.label);

                // //('selectedCategory',selectedCategory);
                

                setItemDetails((prev) => ({
                    ...prev,
                    [`${fieldName}_id`]: value.value
                }));

                setItemDetails((prev) => ({
                    ...prev,
                    [fieldName]: value.label
                }));
            }
        } else if (fieldName === "Kitchen") {
            const isRegistered = kitchenOptions.some((kitchen) => kitchen.label === value.label);
            //(isRegistered, "kitc isReg")
            if (!isRegistered) {
                const confirmRegister = window.confirm("Not Registered. Do you want to register this kitchen?");
                if (confirmRegister) {
                    //("2kit", value);
                    //("User chose to register the kitchen:", value);
                    const today = new Date();
                    const newKitchen = { KitchenName: value.value || value, KitchenCode: value.label || value, Date: today };
                    //('newKitchen', newKitchen);

                    setKitchenOptions((prev) => [...prev, newKitchen]);
                    //(newKitchen, "newKitchen new")
                    // Send new kitchen to the backend
                    fetch(`${api_base_url}/KitchenReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(newKitchen),
                    })
                        .then((response) => {
                            if (response.ok) {
                                //("Kitchen registered successfully!");
                                toast.success("Kitchen registered successfully!", {
                                    className: 'custom-toast',
                                    bodyClassName: 'custom-toast-container',
                                    closeButtonClassName: 'custom-toast-close-button',
                                    onClose: () => { }
                                })
                                setKitchenFromDb(value)
                                const lastValue = kitchenOptions.length > 0 ? kitchenOptions[kitchenOptions.length - 1].value + 1 : 1;

                                // //('categories',categories);
                                // //('selectedCategory',selectedCategory);
                                
                                setItemDetails((prev) => ({
                                    ...prev,
                                    [`${fieldName}_id`]: lastValue
                                }));

                                setItemDetails((prev) => ({
                                    ...prev,
                                    [fieldName]: value.label
                                }));
                            } else {
                                console.error("Failed to register kitchen.");
                            }
                        })
                        .catch((error) => console.error("Error registering kitchen:", error));
                } else {
                    //("User declined to register the kitchen.");
                    return; // Exit if the user does not want to register
                }
            } else {
                setKitchenFromDb(value)
                setItemDetails((prev) => ({
                    ...prev,
                    [`${fieldName}_id`]: value.value
                }));

                setItemDetails((prev) => ({
                    ...prev,
                    [fieldName]: value.label
                }));
            }
        } else if (fieldName === "FoodType") {
            // //("foodttyyppppeeee");

            const isRegistered = foodTypeOptions.some((type) => type.label === value.label);
            //(isRegistered, "kitc isReg")
            if (!isRegistered) {
                //("1");

                const confirmRegister = window.confirm("Not Registered. Do you want to register this foodtype?");
                if (confirmRegister) {
                    //("2", value);

                    //("User chose to register the kitchen:", value);
                    const today = new Date();
                    const newFoodType = { FoodType_name: value.value || value, Date: today };
                    // //('newFoodType',newFoodType);
                    // const fData = JSON.stringify(newFoodType)
                    // //('fData',fData);

                    setFoodTypeOptions((prev) => [...prev, newFoodType]);
                    //(newKitchen, "newKitchen new")
                    // Send new kitchen to the backend
                    const response = await axios.post(
                        `${api_base_url}/FoodTypeReg/${logginedDB}/${JSON.stringify(eventDetails)}`, newFoodType
                    );

                    //("response", response)
                    if (response.status === 200) {
                        toast.success("footType registered successfully!", {
                            className: 'custom-toast',
                            bodyClassName: 'custom-toast-container',
                            closeButtonClassName: 'custom-toast-close-button',
                            onClose: () => { }
                        })
                        setFoodTypeFromDb(value)
                        const lastValue = foodTypeOptions.length > 0 ? foodTypeOptions[foodTypeOptions.length - 1].value + 1 : 1;

                        // //('categories',categories);
                        // //('selectedCategory',selectedCategory);
                        
                        setItemDetails((prev) => ({
                            ...prev,
                            [`${fieldName}_id`]: lastValue
                        }));

                        setItemDetails((prev) => ({
                            ...prev,
                            [fieldName]: value.label
                        }));
                    }

                    // fetch(`${api_base_url}/FoodTypeReg/${logginedDB}`, {
                    //     method: "POST",
                    //     headers: {
                    //         "Content-Type": "application/json",
                    //     },
                    //     body: JSON.stringify(newFoodType),
                    // })
                    //     .then((response) => {
                    // //("22");

                    //         if (response.ok) {
                    // //("3");

                    //             //("Kitchen registered successfully!");
                    //             toast.success("footType registered successfully!", {
                    //                 className: 'custom-toast',
                    //                 bodyClassName: 'custom-toast-container',
                    //                 closeButtonClassName: 'custom-toast-close-button',
                    //                 onClose: () => { }
                    //             })
                    //         } else {
                    // //("4");

                    //             console.error("Failed to register footType.");
                    //         }
                    //     })
                    // .catch((error) => console.error("Error registering footType:", error));
                } else {
                    //("7");

                    //("User declined to register the kitchen.");
                    return; // Exit if the user does not want to register
                }
            } else {
                // setFoodTypeFromDb(value)
                //("fieldName",itemDetails, selectedOption);
                setFoodTypeFromDb(value)
                setItemDetails((prev) => ({
                    ...prev,
                    [`${fieldName}_id`]: value.value
                }));

                setItemDetails((prev) => ({
                    ...prev,
                    [fieldName]: value.label
                }));
            // setSelectedOption((prev) => ({
            //     ...prev,
            //     [fieldName]: value,
            // }));
            // setItemDetails((prev) => ({
            //     ...prev,
            //     [fieldName]: value,
            // }));
                // return
            }
        }
        //("fieldName", fieldName);
        
        // if (fieldName === 'FoodType') {
        //     //("fieldName",itemDetails, selectedOption);
            
        //     setSelectedOption((prev) => ({
        //         ...prev,
        //         [fieldName]: value,
        //     }));
        //     // setItemDetails((prev) => ({
        //     //     ...prev,
        //     //     [fieldName]: value,
        //     // }));
        // } else {
        //     // General logic for updating state
        //     //(" else fieldName", fieldName);
            
        //     setSelectedOption((prev) => ({
        //         ...prev,
        //         [fieldName]: value,
        //     }));
        //     //("selectedOption", selectedOption);
            
        //     setItemDetails((prev) => ({
        //         ...prev,
        //         [fieldName]: value,
        //     }));
        //     //("itemDetails",itemDetails);
            
        // }
        if (fieldName === 'tax') {
            setTaxFromDb(value)
            setItemDetails((prev) => ({
                ...prev,
                'Tax': value.value, // Track the typed value for kitchen
            }));
        } 

        if (fieldName === 'production_link_item_id') {
            setPoolFromDb(value)
            setItemDetails((prev) => ({
                ...prev,
                'production_link_item_id': value ? value.value : null
            }));
        } 
        
        item[itemField] = ''; // Reset the corresponding field
    };

    useEffect(() => {
        if (itemDetails) {
            //(itemDetails, "Item")
            setSelectedOption((prev) => ({
                ...prev,
                Category: categories.find(c => c.label === itemDetails.category || c.value === itemDetails.category) || null,
                Kitchen: kitchenOptions.find(k => k.label === itemDetails.kitchen || k.value === itemDetails.kitchen) || null,
                subKitchen: subKitchenOptions.find(sk => sk.label === itemDetails.subKitchen || sk.value === itemDetails.subKitchen) || null,
                tax: taxOptions.find(tx => tx.label === itemDetails.name || tx.value === itemDetails.id_tax) || null,
                foodType: foodTypeOptions.find(ft => ft.label === itemDetails.foodType || ft.value === itemDetails.foodType) || null
            }));
        }
        //("Updated selectedOption:", selectedOption);
    }, [itemDetails, categories, kitchenOptions, subKitchenOptions
        , foodTypeOptions
    ]);
    

    const handleFocusSelect = (itemField) => {
        setItem({
            ...item,
            [itemField]: ""
        })
    }

    const FoodType = [
        { value: '1', label: 'Veg' },
        { value: '2', label: 'Non Veg' }
    ];

    const Kitchen_Options = [
        { value: '1', label: 'D' },
        { value: '2', label: 'E' },
        { value: '3', label: 'F' }
    ];

    const fileInputRef = useRef(null); // Ref for accessing file input element
    const [image, setImage] = useState(null);

    //(image);
    

    // //('preview',preview);

    const [loading, setLoading] = useState(false); // State to track loading indicator

    const variantRef = useRef(null)
    const priceRef = useRef(null)
    const addonRef = useRef(null)

    const handleDivClick = () => {

        if (preview) return
        // Click the hidden file input element
        return fileInputRef.current.click();
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        //(file);
        
        if (file) {
            setLoading(true); // Set loading to true when starting to load
            setImage(file);

            // Preview the image immediately
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
                setLoading(false);
            };
            reader.readAsDataURL(file);
            // setLoading(false);
        }
    };

    // useEffect(() => {
    //     if (item?.imgName) {
    //         setPreview(`${api_base_url}/uploads/${customerCode}/${logginedDB}/items/${item.imgName}`);
    //     }
    // }, [item, api_base_url, customerCode, logginedDB]);


    const [searchingWeb,setSearchingWeb] = useState(false)

    const handleGenerateWebImg = async (e) => {
        e.stopPropagation()
        
        if (!itemDetails.itemName) return alert("Item Name required!");
        setSearchingWeb(true);
        setPreview(null);
    
        try {
            const response = await axios.get(`${api_base_url}/GetWebGeneratedImage/${itemDetails.itemName}`);
            if (response.status === 200) {
                setSearchingWeb(false);
    
                const base64Image = response.data.base64Image;
                const byteArray = response.data.data;
    
                // if (base64Image) {
                //     // If base64Image exists, use it to create the Blob
                //     const base64 = base64Image.split(',')[1]; // Remove "data:image/x-icon;base64," prefix
                //     const binaryData = atob(base64);
                //     const buffer = new Uint8Array(binaryData.length);
    
                //     for (let i = 0; i < binaryData.length; i++) {
                //         buffer[i] = binaryData.charCodeAt(i);
                //     }
    
                //     const blob = new Blob([buffer], { type: 'image/x-icon' }); // MIME type matches the prefix in base64Image
    
                //     if (blob.size > 0) {
                //         const file = new File([blob], `${itemDetails.itemName}.ico`, { type: 'image/x-icon' });
                //         setPreview(URL.createObjectURL(file));
                //         setImage(file);
                //     } else {
                //         console.error("Blob size is zero, invalid image data.");
                //     }
                // } else if (byteArray) {
                //     // If byteArray exists, use it to create the Blob
                //     const blob = new Blob([new Uint8Array(byteArray)], { type: 'image/x-icon' });
    
                //     if (blob.size > 0) {
                //         const file = new File([blob], `${itemDetails.itemName}.ico`, { type: 'image/x-icon' });
                //         setPreview(response.data.base64Image);
                //         setImage(file);
                //     } else {
                //         console.error("Blob size is zero, invalid image data.");
                //     }
                // } else {
                //     console.error("No valid image data found in the response.");
                // }
                if (base64Image) {
                    const blob = new Blob([Uint8Array.from(atob(base64Image.split(',')[1]), c => c.charCodeAt(0))], { type: 'image/png' });
                    const file = new File([blob], `${item.itemName}.png`, { type: 'image/png' });
                    setPreview(URL.createObjectURL(file));
                    setImage(file);
                } else if (byteArray) {
                    const blob = new Blob([new Uint8Array(byteArray)], { type: 'image/png' });
                    const file = new File([blob], `${item.itemName}.png`, { type: 'image/png' });
                    setPreview(URL.createObjectURL(file));
                    setImage(file);
                } else {
                    console.error("No valid image data found in the response.");
                }
            }
        } catch (error) {
            console.error("Error generating web image:", error);
        }
    };

    const navigate = useNavigate(null)
    const toGetBack = () => {
        navigate('/BaseMenuReg')
    }



    const [addVarient, setAddVarient] = useState(false)
    const [variantRequireError, setVariantRequireError] = useState(false)
    const [variantRequireErrorTimeOut, setVariantRequireErrorTimeOut] = useState(false)
    // const toAddVarient = () => {
    //     if ((Object.keys(itemDetails).length > 1) & (itemDetails.itemName !== '') & (itemDetails.itemCode !== '')){
    //         setVariantRequireError(false)
    //         setAddVarient(true)
    //     } else {
    //         // alert("hi")
    //         setVariantRequireError(true)
    //     }
    //     // //(itemDetails);
    // }

    const parentRef = useRef(null);

    const [isHovered, setIsHovered] = useState(false);

    const [itemInfo, setItemInfo] = useState(true)
    const [itemVariant, setItemVariant] = useState(false)
    const [itemAddons, setItemAddons] = useState(false)
    const [itemPrice, setItemPrice] = useState(false)
    const handleitemInfo = () => {
        setItemInfo(true)
        setItemVariant(false)
        setItemPrice(false)
        setItemAddons(false)
    }
    const handleitemVariant = () => {
        if (!variantRequireError) {
            setItemVariant(true)
            setItemPrice(false)
            setItemAddons(false)
            setItemInfo(false)
        }
    }
    const handleitemPrice = () => {
        if (!priceRequireError) {
            setItemPrice(true)
            setItemAddons(false)
            setItemInfo(false)
            setItemVariant(false)
        }
    }

    const [buttonStandard, setButtonStandard] = useState(true)
    const [buttonVariants, setButtonVariants] = useState(false)
    const [buttonCombo, setButtonCombo] = useState(false)
    const handleButtonStandard = () => {
        setButtonStandard(true)
        setButtonVariants(false)
        setButtonCombo(false)
    }
    const handleButtonVariants = () => {
        setButtonStandard(false)
        setButtonVariants(true)
        setButtonCombo(false)
    }
    const handleButtonCombo = () => {
        setButtonStandard(false)
        setButtonVariants(false)
        setButtonCombo(true)
    }

    
    const handleOnChangeItem = (e, fieldName, itemField) => {
        const value = e.target.value
        setItemDetails((prev) => ({
            ...prev,
            [fieldName]: value
        }))
        
        item[itemField] = ''
    }

    useEffect(() => {
        if ((Object.keys(itemDetails).length >= 4) & (itemDetails.itemName !== '') & (itemDetails.itemCode !== '')
            & (itemDetails.Category !== '') & (itemDetails.Food_Type !== '') & (itemDetails.Kitchen !== '')
            // & (itemDetails.Tax) & (itemDetails.regionalName) & (itemDetails.SubKitchen) & (itemDetails.Cess) 
        ) {
            setVariantRequireError(false);
        } else {
            setVariantRequireError(true);
        }
    }, [itemDetails, variantRequireError]);

    // //(Object.keys(itemDetails).length);
    // //(itemDetails);


    const [priceDetails, setPriceDetails] = useState({ normalPrice: 0 })
    // const [respectedAreaPrice,setRespectedAreaPrice] = useState({})

    // const handleOnChangePrice = (e, fieldName) => {
    //     const newValue = e.target.value;
    //     // Update priceDetails using setPriceDetails
    //     setPriceDetails(prev => ({
    //         ...prev,
    //         [fieldName]: formatInputValue(newValue,fieldName)
    //     }));
    // };

    useEffect(() => {
        if (priceDetails.normalPrice) {
            area.forEach(area => {
                respectedAreaPrice(area.ContainerCharge, area.AreaName);
            });
        }
    }, [priceDetails.normalPrice]);


    const handleOnChangePrice = (e, fieldName) => {
        const newValue = e.target.value;

        // Validate and format the new value
        const formattedValue = formatInputValue(newValue, fieldName);

        if (fieldName === 'normalPrice') {
            // Update normalPrice in priceDetails
            setPriceDetails(prev => {

                const updatedPriceDetails = {
                    ...prev,
                    [fieldName]: !newValue ?'' : formattedValue
                };

                // Recalculate respected area prices if normalPrice is updated
                area.forEach(area => { 
                    respectedAreaPrice(area.ContainerCharge, area.AreaName);
                });

                return updatedPriceDetails;
            });
        } else {

            // Update respected area price in both respectedAreaPriceState and priceDetails
            setRespectedAreaPriceState1(prev => {
                const updatedState = {
                    ...prev,
                    [fieldName]: respectedAreaPriceState1[fieldName] === '' ? 0 : newValue
                };

                // Update priceDetails with the respected area price
                setPriceDetails(prevDetails => ({
                    ...prevDetails,
                    [fieldName]: formattedValue
                }));

                return updatedState;
            });
        }
    };

    const handleOnBlurPrice = (percent, fieldName) => {
        if (respectedAreaPriceState1[fieldName] === '') {
            setRespectedAreaPriceState1((prev) => ({
                ...prev,
                [fieldName]: null
            }))
            respectedAreaPrice(percent, fieldName);
        }
    }

    const handleOnFocusPrice = (fieldName) => {
        if (fieldName === 'normalPrice') {
            if (priceDetails[fieldName] === 0) {
                setPriceDetails(prevDetails => ({
                    ...prevDetails,
                    [fieldName]: ''
                }));
            }
        }
    }

    // Function to format input value to ensure it has 2 decimal places
    const formatInputValue = (value, fieldName) => {
        // Regex to match number with up to 2 decimal places
        const regex = /^\d*(\.\d{0,2})?$/;

        // Check if the input matches the regex pattern
        if (regex.test(value)) {
            // Return the formatted value
            return value;
        } else {
            // If input is invalid, return previous value
            return priceDetails[fieldName];
        }
    };

    // const [respectedAreaPriceState,setRespectedAreaPriceState] = useState('')
    // // Function to calculate respected area price
    // const respectedAreaPrice = (percent, fieldName) => {
    //     const normalPrice = parseFloat(priceDetails.normalPrice);
    //     const areaPercent = normalPrice * (percent / 100);
    //     const totalPrice = normalPrice + areaPercent;
    //     setRespectedAreaPriceState((prev) => ({
    //         ...prev,
    //         [fieldName]: totalPrice.toFixed(2)
    //     }))
    // };

    const [respectedAreaPriceState, setRespectedAreaPriceState] = useState({});
    const [respectedAreaPriceState1, setRespectedAreaPriceState1] = useState({});


    // //('respectedAreaPriceState',respectedAreaPriceState);
    // //('retate1',respectedAreaPriceState1);

    // //('item',);
    

    useEffect(() => {
        if (Object.keys(item).length >0) { 
            //(item.areaRates);
            
            const initialState = {};
            
            area.forEach(areaItem => {
                const matchedRate = item.areaRates.find(rate => rate.areaId === areaItem.Area_id);
                initialState[areaItem.AreaName] = matchedRate ? matchedRate.areaRate : 0; // Default to 0 if not found
            });
    
            //('initialState', initialState);
            setRespectedAreaPriceState(initialState);
            setPriceDetails(prev => ({
                ...prev,
                'normalPrice' : item.rate
            }))
        }
    }, [area, item]); // Runs when `area` or `item` changes
    
    
    const respectedAreaPrice = (percent, fieldName) => {
        if (priceDetails.normalPrice === 0) {

            setRespectedAreaPriceState(prev => {
                const updatedState = {
                    ...prev,
                    [fieldName]: 0
                };
                return updatedState;
            });
        } else {
            const normalPrice = parseFloat(priceDetails.normalPrice);
            if (isNaN(normalPrice)) return; // Avoid calculations if normalPrice is invalid

            const areaPercent = normalPrice * (percent / 100);
            const totalPrice = normalPrice + areaPercent;

            setRespectedAreaPriceState(prev => {
                const updatedState = {
                    ...prev,
                    [fieldName]: Math.round(totalPrice).toFixed(2)
                };
                return updatedState;
            });
            // Update priceDetails with the respected area price
            setPriceDetails(prevDetails => ({
                ...prevDetails,
                [fieldName]: Math.round(totalPrice).toFixed(2)
            }));
        }

    };



    const [variantDetails, setVariantDetails] = useState({})
    const handleOnChangeVariant = (e, fieldName) => {
        const value = e.target.value
        setVariantDetails((prev) => ({
            ...prev,
            [fieldName]: value
        }))
    }

    const toClear = () => {

    }

    const [editingItem, setEditingItem] = useState(null);

    const [priceRequireError,setPriceRequireError] = useState(false)

    const [variant_Price, setVariant_Price] = useState([{ itemName: null, itemPrice: null, isAdding: true }])

    useEffect(() => {
        // //(priceDetails);
        
        if (priceDetails.normalPrice !== 0 && priceDetails.normalPrice !== '0') {
            
            setVariantRequireError(true)
        } else {

            setVariantRequireError(false)
            
        }
        if (variant_Price[0].itemName) {
            setPriceRequireError(true)
        } else {
            setPriceRequireError(false)

        }
    },[priceDetails,variant_Price])
    // //("categories out",categories);
    
    const handleSaveSubmit = async () => {

         const itemName = (itemDetails.itemName || "").trim();
     const itemCode = (itemDetails.itemCode || "").trim();

        if (!itemName || !itemCode) {
        alert("Item Name and Item Code are required.");
        return;
        }

        

        if (priceDetails.normalPrice > 0 || variant_Price[0].itemName !== null ) {
            try {
                // Create a new FormData object
                const formData = new FormData();
                // Append your data to FormData
                formData.append('itemDetails', JSON.stringify(itemDetails));
                formData.append('priceDetails', JSON.stringify(priceDetails));
                formData.append('variant_Price', JSON.stringify(variant_Price));
                formData.append('DB', JSON.stringify(logginedDB));
                formData.append('Company', JSON.stringify(customerCode));
                //("item", item);
                // //(image, "img", item.imgName);
                
                // if (image || item.imgName) {
                    //("inside if");
                    
                    // const getFirstLetters = (text) => {
                    //     return text
                    //         .split(' ')  // Split the text by spaces to get each word
                    //         .map(word => word.charAt(0).toUpperCase())  // Get the first letter of each word and capitalize it
                    //         .join('');  // Join the letters together
                    // };
    
                    // // Get the first letters from itemName
                    // const itemName = (itemDetails.itemName || '').trim();
                    // const firstLetters = getFirstLetters(itemName);
    
                    // // Create the custom name for the file
                    // const customName = firstLetters + itemDetails.itemCode
                    formData.append('file', image);  // Assuming image is a File object
                    // formData.append('customName', itemName);
                    formData.append('IsThere', image ? 1 : 0);
                // }

                //('imaaaaaaaaaaaaaaage',image);
                
    
                    formData.append('id', item.id_productReg);
                    formData.append('img', item.imgName);

                    const response = await fetch(`${api_base_url}/EditItemReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
                        method: 'POST',
                        body: formData,
                    });
    
                if (response.ok) {
                    const data = await response.json();
                    if (data.success) {
                        toGetBack()
                        // Handle successful upload here
                    } else {
                    }
                } else {
                    console.error('Network response was not ok:', response.statusText);
                }
            } catch (error) {
                console.error(error);
            }
        } else {
            return alert("Price is Required!")
        }
        
    }

    
    const handleOnChangeValue = (e, index, item) => {
        const value = e.target.value;

        // Create a copy of the variants array
        const updatedVariant = [...variant_Price];

        // Update the respective item (itemName or itemPrice) at the given index
        updatedVariant[index] = {
            ...updatedVariant[index],
            [item]: value,
        };

        // Update the state with the modified variants array
        setVariant_Price(updatedVariant);
    };

    const [addonErrors, setAddonErrors] = useState({});
    // Function to handle adding variants
    const handleAddOrDeleteVariants = (index) => {
        // Retrieve the current addon combo
        const currentVariant = variant_Price[index];

        // Initialize errors for the current index
        const errors = { ...addonErrors };

        // Check if both itemName and itemPrice are provided
        if (currentVariant.itemName && currentVariant.itemPrice) {
            if (currentVariant.isAdding) {
                const newVariant = { itemName: '', itemPrice: '', isAdding: false };
                const updatedVariant = [...variant_Price];

                // Preserve the value of the current input fields and mark it as not adding
                updatedVariant[index] = {
                    ...updatedVariant[index],
                    isAdding: false,
                };

                updatedVariant.push({ itemName: '', itemPrice: '', isAdding: true });
                setVariant_Price(updatedVariant);
            } else {
                // Remove the item at the given index
                const updatedVariant = variant_Price.filter((variant, idx) => idx !== index);
                setVariant_Price(updatedVariant);
            }

            // Clear errors for the current index
            errors[index] = {
                itemName: !currentVariant.itemName,
                itemPrice: !currentVariant.itemPrice,
            };
            setAddonErrors(errors);
        } else {
            // Set specific errors for itemName and itemPrice
            errors[index] = {
                itemName: !currentVariant.itemName,
                itemPrice: !currentVariant.itemPrice,
            };
            setAddonErrors(errors);
        }
    };

    const handleOnBlurItemName = (index) => {
        // Get the itemName value for the specific index
        const itemName = variant_Price[index].itemName;
        const state = variant_Price[index].isAdding;

        // Check if itemName is empty
        if (itemName.length <= 0 && !state) {
            // Remove the item if itemName is empty
            const updatedVariant = variant_Price.filter((variant, idx) => idx !== index);
            setVariant_Price(updatedVariant);
        }
    };

    const [sideNav, setSideNav] = useState(false)
    const handleSideNav = (state) => {
        setSideNav(state)
    }
    const [falseState, setFalseState] = useState(null)

    const [infoVarient, setInfoVarient] = useState(false)

    return (
        <div className='w-screen xl:h-screen lg:h-full h-screen flex lg:pb-3 xl:pb-0 overflow-x-hidden'>
            <div className='w-full h-full hidden sm:flex sm:flex-col '>
                <SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
                <div className='w-full bg-[#f5f5f5] flex gap-3 h-full'>
                    <div className='w-max h-full z-[9999]'>
                        <SideNav focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)} />
                    </div>
                    <div className='w-full h-full flex flex-col gap-3 pr-3 pb-3'>
                        <div className="h-max">
                            <TopRootDiv image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={'Edit Item'} />
                        </div>
                        <div className='h-full w-full flex flex-col bg-[#fff] gap-0 rounded-t-[.313rem]'>
                            <div className='w-full h-max flex text-center font-nunito font-[600] rounded-t-[.313rem]'>
                                <button className={`w-1/3 p-[1rem] borderItem flex justify-center cursor-pointer items-center rounded-tl-[.313rem] ${itemInfo ? 'bg-[#0008B4] text-[#fff]' : ""}`} onClick={handleitemInfo}>Details</button>
                                <div className={`w-1/3 p-[1rem] borderItem flex justify-center cursor-pointer items-center ${itemPrice ? 'bg-[#0008B4] text-[#fff]' : priceRequireError ? "text-[rgba(0,0,0,0.5)]" : ""}`} onClick={handleitemPrice}>Price</div>
                                <div className={`w-1/3 p-[1rem] borderItem flex justify-center cursor-pointer items-center rounded-tr-[.313rem] gap-2 relative ${itemVariant ? 'bg-[#0008B4] text-[#fff]' : variantRequireError ? "text-[rgba(0,0,0,0.5)]" : ""}`} onClick={handleitemVariant}>
                                    <span>Modifiers/Variant</span>
                                    {
                                        variantRequireError && (
                                            <div className='absolute flex justify-center items-center transform translate-x-[500%]'>
                                                <div className='flex justify-center items-center relative'>
                                                    <img className='w-[1rem] opacity-75 cursor-pointer' src={Info} alt="" 
                                                    onMouseEnter={() => setInfoVarient(true)}
                                                    onMouseLeave={() => setInfoVarient(false)}/>
                                                    {infoVarient && (
                                                        <div className='absolute w-[10rem] h-max text-[#000] bg-[#fff] text-[.9rem] font-[500] transform translate-y-[90%] right-0 p-2 shadow-md border rounded-md'>
                                                            Please fill the required Info
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                {/* <div className={`MenuReg_List_discount ${itemAddons ? 'MenuActive' : ""}`} onClick={handleitemAddons}>Addons/Combo</div> */}
                            </div>
                            {itemInfo && (
                                <div className='p-3 w-full h-full flex flex-col lg:gap-1 gap-3'>
                                    <div className='flex w-full h-max'>
                                        <div className='MenuAddItem_itemInfo_TitleDivHead'>
                                            <span className='itemInfo_TitleDivHeadSpan'>Item Info</span>
                                        </div>
                                        <div className='MenuAddItem_itemInfo_TitleDivTail font-[600]'>
                                            <button className='loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={toGetBack}>Cancel</button>
                                            <button className='loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={handleSaveSubmit}>Save</button>
                                        </div>
                                    </div>
                                    <div className='w-full h-full flex'>
                                        <div className='w-max h-max flex flex-col justify-center items-center gap-3 pt-3 lg:pt-1 xl:pt-3'>
                                            {/* <div className='w-[14.8rem] h-[14.8rem] flex justify-center items-center borderDashed rounded-[.313rem]' onClick={handleDivClick}>
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleImageChange(e, 'itemImage')}
                                                />
                                                {(loading || searchingWeb) ? (
                                                    loading ? <div className='loading-indicator'>Uploading...</div> : 
                                                    searchingWeb ? <Lottie animationData={searchingLotties} loop={true} /> : null
                                                ) : preview ? (
                                                    <div className='w-full h-full relative'>
                                                        <img className='w-full h-full rounded-[.313rem]' src={preview} alt="Uploaded" />
                                                        <div className='absolute top-0 right-0 p-1 rounded-bl-[.313rem] rounded-tr-[.313rem] bg-[#fff] cursor-pointer' onClick={(e) => {
                                                            e.stopPropagation()
                                                            setPreview(null)
                                                            setImage(null)
                                                        }}>
                                                            <img className='w-[1rem]' src={cross} alt="" /> 
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='flex flex-col justify-center items-center gap-2 text-[.75rem]'>
                                                        <img className={`w-[2rem]`} src={UploadImg} alt="Upload Image" />
                                                        <span className='text-center mt-2'>Drag your file here <br /> Or</span>
                                                        <button className='border rounded-[.313rem] px-3 py-1' onClick={(e) => handleGenerateWebImg(e)}>Browse Files</button>
                                                    </div>
                                                )}
                                                 <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleImageChange(e, 'itemImage')}
                                                />
                                                {(loading || searchingWeb) ? (
                                                    loading ? <div className='loading-indicator'>Uploading...</div> : 
                                                    searchingWeb ? <Lottie animationData={searchingLotties} loop={true} /> : null
                                                ) : preview ? (
                                                    <div className='w-full h-full relative'>
                                                        <img className='w-full h-full rounded-[.313rem]' src={preview} alt="Uploaded" />
                                                        <div
                                                            className='absolute top-0 right-0 p-1 rounded-bl-[.313rem] rounded-tr-[.313rem] bg-[#fff] cursor-pointer'
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setPreview(null);
                                                                setImage(null);
                                                            }}
                                                        >
                                                            <img className='w-[1rem]' src={cross} alt="Remove" />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='flex flex-col justify-center items-center gap-2 text-[.75rem]'>
                                                        <img className='w-[2rem]' src={UploadImg} alt="Upload Image" />
                                                        <span className='text-center mt-2'>Drag your file here <br /> Or</span>
                                                        <button className='border rounded-[.313rem] px-3 py-1' onClick={handleGenerateWebImg}>
                                                            Browse Files
                                                        </button>
                                                    </div>
                                                )}
                                            </div> */}
                                        </div>

                                        <div className='w-max h-max flex flex-col justify-center items-center gap-3 xl:pt-3 lg:pt-1 pt-3'> 
                                            <div className='w-[14.8rem] h-[14.8rem] flex justify-center items-center borderDashed rounded-[.313rem]' onClick={handleDivClick}>
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={handleImageChange}
                                                />
                                                {(loading || searchingWeb) ? (
                                                    loading ? <div className='loading-indicator'>Uploading...</div> : 
                                                    searchingWeb ? <Lottie animationData={searchingLotties} loop={true} /> : null
                                                ) : preview ? (
                                                    <div className='w-full h-full relative'>
                                                        <img className='w-full h-full rounded-[.313rem]' src={preview === 'undefined' ? noImage : preview} alt="Uploaded" />
                                                        <div
                                                            className='absolute top-0 right-0 p-1 rounded-bl-[.313rem] rounded-tr-[.313rem] bg-[#fff] cursor-pointer'
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setPreview(null);
                                                                setImage(null);
                                                            }}
                                                        >
                                                            <img className='w-[1rem]' src={cross} alt="Remove" />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='flex flex-col justify-center items-center gap-2 text-[.75rem]'>
                                                        <img className='w-[2rem]' src={UploadImg} alt="Upload Image" />
                                                        <span className='text-center mt-2'>Drag your file here <br /> Or</span>
                                                        <button className='border rounded-[.313rem] px-3 py-1' onClick={handleGenerateWebImg}>
                                                            Browse Files
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div className='flex w-full flex-col pl-3  font-nunito text-[1rem] gap-3 lg:gap-1 xl:gap-3'>
                                            <div className='flex w-full gap-3'>
                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Item Name</span>
                                                    <input className='p-2 h-[2.5rem]' type="text"
                                                        // className={variantRequireErrorTimeOut ? "varientErrorColor" : ""}
                                                        value={itemDetails.itemName || ''}
                                                        // disabled={savedItemDetailStateManage}
                                                        onChange={(e) => handleOnChangeItem(e, 'itemName', 'itemName')} />
                                                </div>
                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Item Code</span>
                                                    <input className='p-2 h-[2.5rem]' type="text"
                                                        // className={variantRequireErrorTimeOut ? "varientErrorColor" : ""}
                                                        value={itemDetails?.itemCode}
                                                        // disabled={savedItemDetailStateManage}
                                                        onChange={(e) => handleOnChangeItem(e, 'itemCode', 'itemCode')} />
                                                </div>
                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Regional Name</span>
                                                    <input className='p-2 h-[2.5rem]' type="text"
                                                        value={itemDetails?.regionalName}
                                                        onChange={(e) => handleOnChangeItem(e, 'regionalName', 'regionalName')} />
                                                </div>
                                            </div>

                                            <div className='flex w-full gap-3'>
                                                <div className="flex flex-col w-1/3 text-left gap-1">
                                                    <span>Select Category</span>
                                                    <Select
                                                        styles={customStyles}
                                                        value={cateFromDb}
                                                        inputValue={itemDetails?.category}
                                                        onFocus={() => handleFocusSelect('category')}
                                                        onChange={(val) => handleSelectField(val, "Category", "category")} // All logic is now centralized
                                                        options={categories}
                                                        // isClearable
                                                        isSearchable
                                                        noOptionsMessage={({ inputValue }) =>
                                                            inputValue ? `No options for "${inputValue}". Press Enter to add.` : "No options available."
                                                        }
                                                        onInputChange={(inputValue) => {
                                                            setItemDetails((prev) => ({
                                                                ...prev,
                                                                category: inputValue, // ✅ Track the typed value

                                                            }));
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter" && itemDetails.category) {
                                                                const inputValue = itemDetails.category.trim();
                                                                const newCategory = { value: inputValue, label: inputValue };
                                                                handleSelectField(newCategory, "Category", "category");
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                
                                                <div className="flex flex-col w-1/3 text-left gap-1">
                                                    <span>Kitchen Select</span>
                                                    <Select
                                                        styles={customStyles}
                                                        value={kitchenFromDb}
                                                        inputValue={itemDetails?.kitchen} // Track the typed value for kitchen
                                                        onFocus={() => handleFocusSelect('kitchen')}
                                                        onChange={(val) => handleSelectField(val, "Kitchen", "kitchen")} // All logic is centralized
                                                        options={kitchenOptions}
                                                        // isClearable
                                                        isSearchable
                                                        noOptionsMessage={({ inputValue }) =>
                                                            inputValue ? `No options for "${inputValue}". Press Enter to add.` : "No options available."
                                                        }
                                                        onInputChange={(inputValue) => {
                                                            setItemDetails((prev) => ({
                                                                ...prev,
                                                                kitchen: inputValue, // Track the typed value for kitchen
                                                            }));
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter" && itemDetails.kitchen) {
                                                                const inputValue = itemDetails.kitchen.trim();
                                                                const newKitchen = { value: inputValue, label: inputValue };
                                                                handleSelectField(newKitchen, "Kitchen", "kitchen");
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Select Food Type</span>
                                                    {/* <Select
                                                        styles={customStyles}
                                                        value={foodTypeFromDb}
                                                        inputValue={item.Food_Type}
                                                        onFocus={() => handleFocusSelect('FoodType')}
                                                        onChange={(val) => handleSelectField(val, 'FoodType', 'FoodType')}
                                                        options={foodTypeOptions}
                                                    /> */}
                                                    <Select
                                                        styles={customStyles}
                                                        value={foodTypeFromDb}
                                                        inputValue={itemDetails?.foodType} // Track the typed value for kitchen
                                                        onFocus={() => handleFocusSelect('FoodType')}
                                                        onChange={(val) => handleSelectField(val, "FoodType", "FoodType")} // All logic is centralized
                                                        options={foodTypeOptions}
                                                        // // isClearable
                                                        isSearchable
                                                        noOptionsMessage={({ inputValue }) =>
                                                            inputValue ? `No options for "${inputValue}". Press Enter to add.` : "No options available."
                                                        }
                                                        onInputChange={(inputValue) => {
                                                            // if (inputValue ) {
                                                                // //("inputValue", inputValue);
                                                                
                                                                setItemDetails((prev) => ({
                                                                    ...prev,
                                                                    foodType: inputValue, // Track the typed value for kitchen
                                                                }));
                                                            // }
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter" && itemDetails.foodType) {
                                                                // //('itemDetails.FoodType', itemDetails.FoodType);

                                                                const inputValue = itemDetails.foodType.trim();
                                                                // //('inputValue', inputValue);

                                                                const newFoodType = { value: inputValue, label: inputValue };
                                                                handleSelectField(newFoodType, "FoodType", "FoodType");
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                
                                            </div>

                                            <div className='flex w-full gap-3'>
                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Sub Kitchen </span>
                                                    <Select
                                                        styles={customStyles}
                                                        value={selectedOption.subKitchen}
                                                        // inputValue={item.kitchen}
                                                        onFocus={() => handleFocusSelect('subKitchen')}
                                                        onChange={(val) => handleSelectField(val, 'subKitchen', 'subKitchen')}
                                                        options={subKitchenOptions}
                                                    />
                                                </div>
                                                
                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Select Tax</span>
                                                    <Select
                                                        styles={customStyles}
                                                        value={taxFromDb} 
                                                        // inputValue={item.Tax}
                                                        onFocus={() => handleFocusSelect('tax')}
                                                        onChange={(val) => handleSelectField(val, 'tax', 'tax')}
                                                        options={taxOptions}
                                                    />
                                                </div>

                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Daily Production Pool Link</span>
                                                    <Select
                                                        styles={customStyles}
                                                        value={poolFromDb}
                                                        onChange={(val) => {
                                                            setPoolFromDb(val);
                                                            handleSelectField(val, 'production_link_item_id', 'production_link_item_id');
                                                        }}
                                                        options={allProductsOptions}
                                                        isClearable
                                                        isSearchable
                                                        placeholder="Select product..."
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                        menuPlacement="auto"
                                                    />
                                                </div>
                                                {/* <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Select Cess</span>
                                                    <input className='p-2 h-[2.5rem]' type="text"
                                                        value={itemDetails.Cess}
                                                        onChange={(e) => handleOnChangeItem(e, 'Cess', 'Cess')} />
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {itemVariant && (
                                <div className='p-3 w-full h-full flex flex-col gap-3' ref={variantRef}>
                                    <div className='MenuAddItem_itemInfo_Title h-max'>
                                        <div className='MenuAddItem_itemInfo_TitleDivHead'>
                                            <span className='itemInfo_TitleDivHeadSpan'>{itemDetails.itemName}</span>
                                        </div>
                                        <div className='MenuAddItem_itemInfo_TitleDivTail font-[600]'>
                                            <button className='loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={toGetBack}>Cancel</button>
                                            <button className='loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={handleSaveSubmit}>Save</button>
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-full h-full font-nunito'>
                                        <div className='w-full h-max flex rounded-t-[.313rem] text-center bg-[#dbdbdb] text-[1rem] font-[600]'>
                                            <div className='w-4/12 text-left p-3'>Variant</div>
                                            <div className='w-4/12 p-3'>Price</div>
                                            <div className='w-2/12 p-3'>Active</div>
                                            <div className='w-2/12 p-3'>Action</div>
                                        </div>
                                        <div className='w-full h-full flex flex-col'>
                                            {variant_Price.map((variant, index) => (
                                                <div className='flex w-full' key={index}>
                                                    <div className='w-4/12 p-3'>
                                                        <input className={`w-full borderBottem ${addonErrors[index]?.itemName ? 'AddonFieldError' : ''}`} type="text"
                                                        value={variant.itemName}
                                                        onBlur={() => handleOnBlurItemName(index)}
                                                        onChange={(e) => handleOnChangeValue(e, index, 'itemName')} />
                                                    </div>
                                                    <div className='w-4/12 p-3'>
                                                        <input className={`w-full borderBottem ${addonErrors[index]?.itemPrice ? 'AddonFieldError' : ''}`} type="number"
                                                        value={variant.itemPrice}
                                                        onBlur={() => handleOnBlurItemName(index)}
                                                        onChange={(e) => handleOnChangeValue(e, index, 'itemPrice')} />
                                                    </div>
                                                    <div className='w-2/12 p-3 flex justify-center items-center'>
                                                        <button>Active</button>
                                                    </div>
                                                    <div className='w-2/12 p-3 flex justify-center items-center'>
                                                        <img className='w-[1.25rem] cursor-pointer' src={variant.isAdding ? AddCombo : Minus1} alt=""
                                                        onClick={() => handleAddOrDeleteVariants(index)} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {itemPrice && (
                                <div className='w-ful h-full flex flex-col' ref={priceRef}>
                                    <div className='flex flex-col'>
                                        <div className='flex flex-col gap-3 p-3'> 
                                            <div className='MenuAddItem_itemInfo_Title'>
                                                <div className='MenuAddItem_itemInfo_TitleDivHead'>
                                                    <span className='itemInfo_TitleDivHeadSpan'>How do you want to price this item?</span>
                                                </div>
                                                <div className='MenuAddItem_itemInfo_TitleDivTail font-[600]'>
                                                    <button className='loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={toGetBack}>Cancel</button>
                                                    <button className='loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={handleSaveSubmit}>Save</button>
                                                </div>
                                            </div>
                                            <div className='itemInfo_PriceDiv_OPtionsDiv'>
                                                <div className={`itemInfo_PriceDiv_OPtionsDivOptions ${buttonStandard ? 'ButtonActive' : ''}`} onClick={handleButtonStandard}>
                                                    {buttonStandard && (
                                                        <img className='itemInfo_PriceDiv_OPtionsDivOptions_Image' src={Tick} alt="" />
                                                    )}
                                                    <span className='itemInfo_PriceDiv_OPtionsDivOptionsSpan'>Standard item with no customizations</span>
                                                </div>
                                                <div className={`itemInfo_PriceDiv_OPtionsDivOptions ${buttonVariants ? 'ButtonActive' : ''}`} onClick={handleButtonVariants}>
                                                    {buttonVariants && (
                                                        <img className='itemInfo_PriceDiv_OPtionsDivOptions_Image' src={Tick} alt="" />
                                                    )}
                                                    <span className='itemInfo_PriceDiv_OPtionsDivOptionsSpan'>Item has Modifiers/Variants/Customizations</span>
                                                </div>
                                                <div className={`itemInfo_PriceDiv_OPtionsDivOptions ${buttonCombo ? 'ButtonActive' : ''}`} onClick={handleButtonCombo}>
                                                    {buttonCombo && (
                                                        <img className='itemInfo_PriceDiv_OPtionsDivOptions_Image' src={Tick} alt="" />
                                                    )}
                                                    <span className='itemInfo_PriceDiv_OPtionsDivOptionsSpan'>This is a combo item</span>
                                                </div>
                                            </div>
                                        </div>
                                        {(buttonStandard || buttonVariants) && (
                                            <div className='flex w-full gap-3 p-3'>
                                                <div className='flex flex-col gap-3'>
                                                    <div className='itemInfo_PriceDiv_Sections_title'>Normal Price</div>
                                                    <div className='itemInfo_PriceDiv_Sections_PriceDiv'>
                                                        <div className='itemInfo_PriceDiv_Sections_PriceDivImage_Div'>
                                                            <img className='itemInfo_PriceDiv_Sections_PriceDivImage_Div_Image' src={Rupee} alt="" />
                                                        </div>
                                                        <input
                                                            className='itemInfo_PriceDiv_Sections_PriceDiv_Input'
                                                            type="number"
                                                            value={priceDetails.normalPrice}
                                                            onChange={(e) => handleOnChangePrice(e, 'normalPrice')}
                                                            onFocus={() => handleOnFocusPrice('normalPrice')}
                                                        // onBlur={() => handleOnBlurPrice('normalPrice')}
                                                        />
                                                    </div>
                                                </div>
                                                {
                                                area.map((area, index) => (
                                                    <div className='flex flex-col gap-3' key={index}>
                                                        <div className='itemInfo_PriceDiv_Sections_title'>{area.AreaName}</div>
                                                        <div className='itemInfo_PriceDiv_Sections_PriceDiv'>
                                                            <div className='itemInfo_PriceDiv_Sections_PriceDivImage_Div'>
                                                                <img className='itemInfo_PriceDiv_Sections_PriceDivImage_Div_Image' src={Rupee} alt="" />
                                                            </div>
                                                            <input
                                                                className='itemInfo_PriceDiv_Sections_PriceDiv_Input'
                                                                type="number"
                                                                value={respectedAreaPriceState1[area.AreaName] ? respectedAreaPriceState1[area.AreaName] :
                                                                    (respectedAreaPriceState1[area.AreaName] === '' || respectedAreaPriceState1[area.AreaName] === 0) ? '' :
                                                                        respectedAreaPriceState[area.AreaName]}

                                                                        
                                                                onChange={(e) => handleOnChangePrice(e, area.AreaName)}
                                                                onBlur={() => handleOnBlurPrice(area.ContainerCharge, area.AreaName)}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* ........................................mobileView................................ */}

            {/* <div className='w-full h-full flex flex-col sm:!hidden overflow-hidden'>
                <div className='w-full h-max sticky top-0'>
                    <NavBarMobile title={'Add Item'}/>
                </div>
                <div className={`relative w-full h-full bg-[#fff] overflow-hidden ${sideNavState ? '' : ''}`} onClick={() =>sideNavStateFunc(true)}>
                    <div className={`h-full w-max absolute left-0 bg-[#f5f5f5] transition-transform duration-5000 z-[9999] ${
                        sideNavState ? "translate-x-0 ease-out shadow-[5px_5px_100px_rgba(0,0,0,0.4)]" : "-translate-x-full ease-in duration-5000"
                    }`}>
                        <SideNavMob focus={'Menu management'}/>
                    </div>
                    <div className={`h-full w-max absolute right-0 bg-[#f5f5f5] transition-transform duration-5000 z-[9999] ${
                        rightNavState ? "-translate-x-0 ease-out shadow-[5px_5px_100px_rgba(0,0,0,0.4)]" : "translate-x-full ease-in duration-5000"
                    }`}>
                        <RightNavMob/>
                    </div>
                    
                    <div className='w-full h-full flex flex-col font-nunito xl:p-3 lg:p-1 p-3 overflow-hidden'>
                        <div className='w-full h-max flex gap-3 text-center font-nunito font-[600] overflow-auto noScroll'>
                            <div className={`w-max flex justify-center items-center px-4 xl:py-2 py-2 lg:py-1.5 rounded-[.313rem] border ${itemInfo ? "bg-[#0008B4] text-[#fff]" : "bg-[#fff]"}`} onClick={handleitemInfo}>
                                <span>Info</span>
                            </div>
                            <div className={`w-max flex justify-center items-center px-4 xl:py-2 py-2 lg:py-1.5 rounded-[.313rem] border ${itemPrice ? "bg-[#0008B4] text-[#fff]" : "bg-[#fff] "}`} onClick={handleitemPrice}>
                                <span>Price</span>
                            </div>
                            <div className={`w-max flex justify-center items-center xl:py-2 py-2 lg:py-1.5 rounded-[.313rem] border relative ${itemVariant ? "bg-[#0008B4] text-[#fff] px-4" : variantRequireError ? "text-[rgba(0,0,0,0.5)] bg-[#eee] pl-3 pr-5" : "bg-[#fff] px-4"}`} onClick={handleitemVariant}>
                                <span>Modifiers/Variant</span>
                                {
                                    variantRequireError && (
                                        <div className='absolute right-0 flex justify-center items-center'>
                                            <div className='flex justify-center items-center relative'>
                                                <img className='w-[1rem] mr-3 opacity-75 cursor-pointer' src={Info} alt="" 
                                                onMouseEnter={() => setInfoVarient(true)}
                                                onMouseLeave={() => setInfoVarient(false)}/>
                                                {infoVarient && (
                                                    <div className='absolute w-[9rem] h-max text-[#000] bg-[#fff] text-[.9rem] font-[500] transform translate-y-[90%] right-0 p-2 shadow-md border rounded-md'>
                                                        Please fill the required Info
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        {itemInfo && (
                            <div className='pt-3 w-full h-full flex flex-col gap-3 overflow-hidden'>
                                <div className='w-full h-full flex flex-col gap-3 overflow-auto noScroll'>
                                    <div className='w-full h-full flex gap-3'>
                                        <div className='w-max h-max'>
                                            <div className='w-[10rem] h-[10rem] flex justify-center items-center borderDashed cursor-pointer rounded-[.313rem]' onClick={handleDivClick}>
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    src={(`${api_base_url}/uploads/${customerCode}/${logginedDB}/items/${itemDetails.imgName}`)}
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleImageChange(e, 'itemImage')}
                                                />
                                                {(loading || searchingWeb) ? (
                                                    loading ? <div className='loading-indicator'>Uploading...</div> : 
                                                    searchingWeb ? <Lottie animationData={searchingLotties} loop={true} /> : null
                                                ) : preview ? (
                                                    <div className='w-full h-full relative'>
                                                        <img className='w-full h-full rounded-[.313rem]' src={preview} alt="Uploaded" />
                                                        <div className='absolute top-0 right-0 p-1 rounded-bl-[.313rem] rounded-tr-[.313rem] bg-[#fff]' onClick={(e) => {
                                                            e.stopPropagation()
                                                            setPreview(null)
                                                            setImage(null)
                                                        }}>
                                                            <img className='w-[1rem]' src={cross} alt="" /> 
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='flex flex-col justify-center items-center gap-2 text-[.75rem]'>
                                                        <img className={`w-[2rem]`} src={UploadImg} alt="Upload Image" />
                                                        <span className='text-center mt-1'>Drag your file here <br /> Or</span>
                                                        <button className='border rounded-lg px-2 py-1' onClick={(e) => handleGenerateWebImg(e)}>Browse Files</button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='w-full h-full flex flex-col justify-start items-end gap-3'>
                                            <div className='flex flex-col w-full text-left gap-2'>
                                                <span>Item Name</span>
                                                <input className='w-full p-2 h-[2.5rem]' type="text"
                                                    // className={variantRequireErrorTimeOut ? "varientErrorColor" : ""}
                                                    value={itemDetails.itemName || ''}
                                                    // disabled={savedItemDetailStateManage}
                                                    onChange={(e) => handleOnChangeItem(e, 'itemName', 'productName')} />
                                            </div>
                                            <div className='flex flex-col w-full text-left gap-2'>
                                                <span>Item Code</span>
                                                <input className='w-full p-2 h-[2.5rem]' type="text"
                                                    // className={variantRequireErrorTimeOut ? "varientErrorColor" : ""}
                                                    value={itemDetails.itemCode || ''}
                                                    // disabled={savedItemDetailStateManage}
                                                    onChange={(e) => handleOnChangeItem(e, 'itemCode', 'itemCode')} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='w-full h-max flex justify-center items-center gap-3'>
                                        <div className='flex flex-col w-1/2 text-left gap-2'>
                                            <span>Regional Name</span>
                                            <input className='p-2 h-[2.5rem]' type="text"
                                                value={itemDetails.regionalName || ''}
                                                onChange={(e) => handleOnChangeItem(e, 'regionalName', 'regionalName')} />
                                        </div>
                                        <div className='flex flex-col w-1/2 text-left gap-2'>
                                            <span>Select Category</span>
                                            <Select
                                                styles={customStyles}
                                                value={itemDetails.Category}
                                                inputValue={itemDetails.category}
                                                onFocus={() => handleFocusSelect('category')}
                                                onChange={(val) => handleSelectField(val, 'Category', 'category')}
                                                options={categories}
                                            />
                                        </div>
                                    </div>
                                    <div className='w-full h-max flex justify-center items-center gap-3'>
                                        <div className='flex flex-col w-1/2 text-left gap-2'>
                                            <span>Kitchen Select</span>
                                            <Select
                                                styles={customStyles}
                                                value={selectedOption.Kitchen}
                                                // inputValue={item.kitchen}
                                                onFocus={() => handleFocusSelect('kitchen')}
                                                onChange={(val) => handleSelectField(val, 'Kitchen', 'kitchen')}
                                                options={kitchenOptions}
                                            />
                                        </div>
                                        <div className='flex flex-col w-1/2 text-left gap-2'>
                                            <span>Sub Kitchen </span>
                                            <Select
                                                styles={customStyles}
                                                value={selectedOption.subKitchen}
                                                // inputValue={item.kitchen}
                                                onFocus={() => handleFocusSelect('subKitchen')}
                                                onChange={(val) => handleSelectField(val, 'subKitchen', 'subKitchen')}
                                                options={subKitchenOptions}
                                            />
                                        </div>
                                    </div>
                                    <div className='w-full h-full flex  items-center gap-3'>
                                        <div className='flex flex-col w-1/2 text-left gap-2'>
                                            <span>Select Food Type</span>
                                            <Select
                                                styles={customStyles}
                                                value={itemDetails.Food_Type}
                                                inputValue={item.Food_Type}
                                                onFocus={() => handleFocusSelect('FoodType')}
                                                onChange={(val) => handleSelectField(val, 'FoodType', 'FoodType')}
                                                options={FoodType}
                                            />
                                        </div>
                                        <div className='flex flex-col w-1/2 text-left gap-2'>
                                            <span>Select Tax</span>
                                            <input className='p-2 h-[2.5rem]' type="text"
                                                value={itemDetails.Tax}
                                                onChange={(e) => handleOnChangeItem(e, 'Tax', 'Tax')} />
                                        </div>
                                    </div>
                                    <div className='w-full h-max flex justify-start items-center gap-3'>
                                                 {/*
                                        <div className='flex flex-col w-1/2 text-left gap-2'>
                                            <span>Select Cess</span>
                                            <input className='p-2 h-[2.5rem]' type="text"
                                                value={itemDetails.Cess}
                                                onChange={(e) => handleOnChangeItem(e, 'Cess', 'Cess')} />
                                        </div>  * /}


                                        <div className='flex flex-col w-1/2 text-left gap-1'></div>
                                    </div>
                                </div>
                                <div className='flex w-full h-max gap-3'>
                                    <button className='w-1/2 loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] py-2' onClick={toGetBack}>Cancel</button>
                                    <button className='w-1/2 loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] py-2' onClick={handleSaveSubmit}>Save</button>
                                </div>
                            </div>
                        )}
                        {itemPrice && (
                            <div className='pt-3 w-full h-full flex flex-col gap-3 overflow-hidden' ref={priceRef}>
                                <div className='w-full h-full flex flex-col gap-3 overflow-auto noScroll'>
                                    <div className='flex flex-col gap-3'>
                                        <div className='relative w-full flex justify-center items-center underline text-[1rem]'>
                                            <span className='w-full'>How do you want to price this item?</span>
                                            {/* <img className='absolute right-2 w-[.8rem]' src={rightarrow} alt="" /> * /}
                                        </div>
                                        <div className='w-full flex flex-col gap-1 text-[.95rem]'>
                                            {(!buttonVariants && !buttonCombo) && (
                                                <div className={`relative w-full bg-[#fff] rounded-[.313rem] border py-2 pl-2 pr-4 flex justify-start items-center cursor-pointer gap-2 ${buttonStandard ? 'ButtonActive' : ''}`} onClick={() => setButtonStandard(!buttonStandard)}>
                                                    <span className=''>Standard item with no customizations</span>
                                                    {buttonStandard ? (
                                                        <img className='absolute right-2 w-[.9rem] invert' src={Upp} alt="" />
                                                    ) : (
                                                        <img className='absolute right-2 w-[.9rem] opacity-50' src={Rightt} alt="" />
                                                    )}
                                                </div>
                                            )}
                                            {(!buttonStandard && !buttonCombo) && (
                                                <div className={`relative w-full bg-[#fff] rounded-[.313rem] border py-2 pl-2 pr-4 flex justify-start items-center cursor-pointer gap-2 ${buttonVariants ? 'ButtonActive' : ''}`} onClick={() => setButtonVariants(!buttonVariants)}>
                                                    
                                                    <span className=''>Item has Modifiers / Variants / Customizations</span>
                                                    {buttonVariants ? (
                                                        <img className='absolute right-2 w-[.9rem] invert' src={Upp} alt="" />
                                                    ) : (
                                                        <img className='absolute right-2 w-[.9rem] opacity-50' src={Rightt} alt="" />
                                                    )}
                                                </div>
                                            )}
                                            {(!buttonVariants && !buttonStandard) && (
                                                <div className={`relative w-full bg-[#fff] rounded-[.313rem] border py-2 pl-2 pr-4 flex justify-start items-center cursor-pointer gap-2 ${buttonCombo ? 'ButtonActive' : ''}`} onClick={() => setButtonCombo(!buttonCombo)}>
                                                    
                                                    <span className=''>This is a combo item</span>
                                                    {buttonCombo ? (
                                                        <img className='absolute right-2 w-[.9rem] invert' src={Upp} alt="" />
                                                    ) : (
                                                        <img className='absolute right-2 w-[.9rem] opacity-50' src={Rightt} alt="" />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {(buttonStandard || buttonVariants) && (
                                        <div className='grid grid-cols-2 gap-3'>
                                            <div className='flex flex-col gap-2'>
                                                <div className='itemInfo_PriceDiv_Sections_title'>Normal Price</div>
                                                <div className='itemInfo_PriceDiv_Sections_PriceDiv'>
                                                    <div className='itemInfo_PriceDiv_Sections_PriceDivImage_Div'>
                                                        <img className='itemInfo_PriceDiv_Sections_PriceDivImage_Div_Image' src={Rupee} alt="" />
                                                    </div>
                                                    <input
                                                        className='itemInfo_PriceDiv_Sections_PriceDiv_Input'
                                                        type="number"
                                                        value={priceDetails.normalPrice}
                                                        onChange={(e) => handleOnChangePrice(e, 'normalPrice')}
                                                        onFocus={() => handleOnFocusPrice('normalPrice')}
                                                    // onBlur={() => handleOnBlurPrice('normalPrice')}
                                                    />
                                                </div>
                                            </div>
                                            {area.map((area, index) => {
                                                // functionToSetTorespectedAreaPriceState(area.Area_id,area.AreaName)
                                                return (
                                                    <div className='flex flex-col gap-2' key={index}>
                                                        <div className='itemInfo_PriceDiv_Sections_title'>{area.Name}</div>
                                                        <div className='itemInfo_PriceDiv_Sections_PriceDiv'>
                                                            <div className='itemInfo_PriceDiv_Sections_PriceDivImage_Div'>
                                                                <img className='itemInfo_PriceDiv_Sections_PriceDivImage_Div_Image' src={Rupee} alt="" />
                                                            </div>
                                                            <input
                                                                className='itemInfo_PriceDiv_Sections_PriceDiv_Input'
                                                                type="number"
                                                                value={respectedAreaPriceState1[area.Name] ? respectedAreaPriceState1[area.Name] :
                                                                    respectedAreaPriceState1[area.Name] === '' || respectedAreaPriceState1[area.Name] === 0 ? '' :
                                                                        respectedAreaPriceState[area.Name]}
                                                                onChange={(e) => handleOnChangePrice(e, area.Name)}
                                                                onBlur={() => handleOnBlurPrice(area.Percent, area.Name)}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                                
                                            })}
                                        </div>
                                    )}
                                </div>
                                <div className='flex w-full h-max gap-3'>
                                    <button className='w-1/2 loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] py-2' onClick={toGetBack}>Cancel</button>
                                    <button className='w-1/2 loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] py-2' onClick={handleSaveSubmit}>Save</button>
                                </div>
                            </div>
                        )}
                        {itemVariant && (
                            <div className='pt-3 w-full h-full flex flex-col gap-3 overflow-hidden' ref={variantRef}>
                                <div className='w-full h-full flex flex-col gap-3 overflow-hidden'>
                                    <div className='MenuAddItem_itemInfo_Title h-max'>
                                        <div className='MenuAddItem_itemInfo_TitleDivHead'>
                                            <span className='itemInfo_TitleDivHeadSpan'>{itemDetails.itemName}</span>
                                        </div>
                                    </div>
                                    <div className='relative flex flex-col w-full h-full font-nunito overflow-auto noScroll'>
                                        <div className='sticky top-0 w-full h-max flex rounded-t-[.313rem] text-center bg-[#dbdbdb] text-[1rem] font-[600]'>
                                            <div className='w-5/12 text-left p-3'>Variant</div>
                                            <div className='w-4/12 p-3'>Price</div>
                                            {/* <div className='w-2/12 p-3'>Active</div> * /}
                                            <div className='w-3/12 p-3 text-center'>Action</div>
                                        </div>
                                        <div className='w-full h-full flex flex-col'>
                                            {variant_Price.map((variant, index) => (
                                                <div className='flex w-full'>
                                                    <div className='w-5/12 p-3'>
                                                        <input className={`w-full borderBottem ${addonErrors[index]?.itemName ? 'AddonFieldError' : ''}`} type="text"
                                                        value={variant.itemName}
                                                        onBlur={() => handleOnBlurItemName(index)}
                                                        onChange={(e) => handleOnChangeValue(e, index, 'itemName')} />
                                                    </div>
                                                    <div className='w-4/12 p-3'>
                                                        <input className={`w-full borderBottem ${addonErrors[index]?.itemPrice ? 'AddonFieldError' : ''}`} type="number"
                                                        value={variant.itemPrice}
                                                        onBlur={() => handleOnBlurItemName(index)}
                                                        onChange={(e) => handleOnChangeValue(e, index, 'itemPrice')} />
                                                    </div>
                                                    {/* <div className='w-2/12 p-3 flex justify-center items-center'>
                                                        <button>Active</button>
                                                    </div> * /}
                                                    <div className='w-3/12 p-3 flex justify-center items-center'>
                                                        <img className='w-[1.25rem] cursor-pointer' src={variant.isAdding ? AddCombo : Minus1} alt=""
                                                        onClick={() => handleAddOrDeleteVariants(index)} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className='flex w-full h-max gap-3'>
                                    <button className='w-1/2 loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] py-2' onClick={toGetBack}>Cancel</button>
                                    <button className='w-1/2 loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] py-2' onClick={handleSaveSubmit}>Save</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default EditItem
